import script from "./StepEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./StepEmail.vue?vue&type=script&setup=true&lang=js"

import "./StepEmail.vue?vue&type=style&index=0&id=ccad0684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccad0684"]])

export default __exports__